import { NotificationBarStatus } from '@/components/common/Feedback/notification-bar/typings';

import {
  DataActivityStatus,
  EmissionSourceCategory,
  EmissionSourceSubCategory,
  OcrCategory,
} from '../enums/EmissionSourceEnum';

class ActivityDataConstants {
  public static readonly CATEGORY_OCR_DOCUMENT_TYPE_MAPPING: Partial<Record<EmissionSourceCategory, OcrCategory>> = {
    [EmissionSourceCategory.CAT_1]: OcrCategory.OIL_BILL,
    [EmissionSourceCategory.CAT_2]: OcrCategory.ELECTRIC_BILL,
  };

  public static readonly STATUS_TO_NOTIFICATION_MAP: Record<DataActivityStatus, NotificationBarStatus> = {
    CREATED: NotificationBarStatus.PENDING,
    SUBMITTED: NotificationBarStatus.PENDING,
    APPROVED: NotificationBarStatus.SUCCESS,
    REJECTED: NotificationBarStatus.FAILED,
    DELETED: NotificationBarStatus.FAILED,
    RESUBMITTED: NotificationBarStatus.PENDING,
    PROCESSING: NotificationBarStatus.PENDING,
  };

  public static readonly STATUS_COLOR: Record<DataActivityStatus | 'REUPLOAD', string> = {
    CREATED: 'teal',
    SUBMITTED: 'orange',
    APPROVED: 'green',
    REJECTED: 'red',
    DELETED: 'red',
    REUPLOAD: 'teal',
    RESUBMITTED: 'teal',
    PROCESSING: 'teal',
  };

  public static readonly DONT_HAVE_EMISSION_CATEGORY: EmissionSourceSubCategory[] = [
    EmissionSourceSubCategory.CAT_3_1,
    EmissionSourceSubCategory.CAT_3_2,
    EmissionSourceSubCategory.CAT_3_3,
    EmissionSourceSubCategory.CAT_3_4,
    EmissionSourceSubCategory.CAT_3_5,
    EmissionSourceSubCategory.CAT_4_1A,
    EmissionSourceSubCategory.CAT_4_2,
    EmissionSourceSubCategory.CAT_4_4,
    EmissionSourceSubCategory.CAT_5_1,
    EmissionSourceSubCategory.CAT_5_2,
    EmissionSourceSubCategory.CAT_5_3,
    EmissionSourceSubCategory.CAT_5_4,
    EmissionSourceSubCategory.CAT_5_5,
    EmissionSourceSubCategory.CAT_5_6,
  ];

  public static readonly EMISSION_KIND_BUNDLE_CATEGORY: EmissionSourceSubCategory[] = [
    EmissionSourceSubCategory.CAT_3_1,
    EmissionSourceSubCategory.CAT_4_1A,
  ];

  public static readonly DISTRIBUTION_BUNDLE_CATEGORY: EmissionSourceSubCategory[] = [
    EmissionSourceSubCategory.CAT_3_2,
    EmissionSourceSubCategory.CAT_5_1,
    EmissionSourceSubCategory.CAT_5_3,
  ];

  public static readonly BIG_GIFT_CATEGORY: EmissionSourceSubCategory[] = [
    EmissionSourceSubCategory.CAT_3_3,
    EmissionSourceSubCategory.CAT_4_2,
    EmissionSourceSubCategory.CAT_4_4,
    EmissionSourceSubCategory.CAT_5_2,
    EmissionSourceSubCategory.CAT_5_4,
    EmissionSourceSubCategory.CAT_5_5,
    EmissionSourceSubCategory.CAT_5_6,
  ];

  public static readonly BIG_GIFT_CATEGORY_WITH_CAT_3_4_CAT_3_5: EmissionSourceSubCategory[] = [
    ...this.BIG_GIFT_CATEGORY,
    EmissionSourceSubCategory.CAT_3_4,
    EmissionSourceSubCategory.CAT_3_5,
  ];

  public static readonly CAN_BULK_INPUT_SUBCATEGORY: EmissionSourceSubCategory[] = [
    EmissionSourceSubCategory.CAT_1_1,
    EmissionSourceSubCategory.CAT_1_2,
    EmissionSourceSubCategory.CAT_1_3,
    EmissionSourceSubCategory.CAT_2_1,
    EmissionSourceSubCategory.CAT_2_2,
    EmissionSourceSubCategory.CAT_3_1,
    EmissionSourceSubCategory.CAT_3_2,
    EmissionSourceSubCategory.CAT_3_3,
    EmissionSourceSubCategory.CAT_3_4,
    EmissionSourceSubCategory.CAT_3_5,
    EmissionSourceSubCategory.CAT_4_1A,
    EmissionSourceSubCategory.CAT_4_2,
    EmissionSourceSubCategory.CAT_4_3,
    EmissionSourceSubCategory.CAT_4_4,
    EmissionSourceSubCategory.CAT_5_1,
    EmissionSourceSubCategory.CAT_5_2,
    EmissionSourceSubCategory.CAT_5_3,
    EmissionSourceSubCategory.CAT_5_4,
    EmissionSourceSubCategory.CAT_5_5,
    EmissionSourceSubCategory.CAT_5_6,
  ];

  public static readonly NO_USAGE_RATIO_SUBCATEGORY: EmissionSourceSubCategory[] = [
    EmissionSourceSubCategory.CAT_3_1,
    EmissionSourceSubCategory.CAT_3_2,
    EmissionSourceSubCategory.CAT_4_1A,
    EmissionSourceSubCategory.CAT_4_3,
    EmissionSourceSubCategory.CAT_4_5,
  ];

  public static readonly REQUIRE_RANGE_DATE_SUBCATEGORY: EmissionSourceSubCategory[] = [
    EmissionSourceSubCategory.CAT_2_1,
    EmissionSourceSubCategory.CAT_2_2,
    EmissionSourceSubCategory.CAT_4_1B,
    EmissionSourceSubCategory.CAT_4_5,
  ];
}

export default ActivityDataConstants;
